

// Create a singleton cache for durations
const durationCache = new Map<string, number>();
const blobCache = new Map<string, Blob>();
// @ts-ignore
const audioContext = new (window.AudioContext || window.webkitAudioContext)();

export const getAudioDuration = async (url: string): Promise<number> => {
    // Check cache first
    if (durationCache.has(url)) {
        return durationCache.get(url)!;
    }

    try {
        // Reuse blob if we have it
        let blob = blobCache.get(url);
        if (!blob) {
            const response = await fetch(url);
            blob = await response.blob();
            blobCache.set(url, blob);
        }

        const arrayBuffer = await blob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        const duration = audioBuffer.duration;
        
        // Cache the result
        durationCache.set(url, duration);
        
        return duration;
    } catch (error) {
        console.error('Error getting audio duration:', error);
        return 0;
    }
};

export const clearAudioCache = (url?: string) => {
    if (url) {
        durationCache.delete(url);
        blobCache.delete(url);
    } else {
        durationCache.clear();
        blobCache.clear();
    }
};
